import { Flex } from '@mantine/core';
import { createContext, ReactNode, useContext, useState } from 'react';
import { createPortal } from 'react-dom';

type BreadcrumbTerminalSlotValue = {
  slot: HTMLElement | null;
  setSlot: (el: HTMLElement | null) => void;
};

const BreadcrumbTerminalSlotContext = createContext<BreadcrumbTerminalSlotValue>({
  slot: null,
  setSlot: () => {},
});

export function BreadcrumbTerminalSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <BreadcrumbTerminalSlotContext.Provider value={{ slot, setSlot }}>
      {children}
    </BreadcrumbTerminalSlotContext.Provider>
  );
}

export function BreadcrumbTerminalSlotHost() {
  const { setSlot } = useContext(BreadcrumbTerminalSlotContext);
  return <Flex display="inline-flex" align="center" gap="xs" c="gray.7" ref={setSlot} />;
}

export function BreadcrumbTerminalSlotFill({ children }: { children: ReactNode }) {
  const { slot } = useContext(BreadcrumbTerminalSlotContext);
  if (!slot) return null;
  return createPortal(children, slot);
}
